import { getImageReference } from "@tiicker/util/lib/contentful/helpers";
import { ContentSection } from "@tiicker/util/lib/contentful/types";
import classNames from "classnames";
import Button from "components/core/Button/Button";
import { Entry } from "contentful";
import React from "react";
import styles from "./NewsCTACard.module.scss";

type Props = {
  section: Entry<ContentSection>;
  cardClassName?: string;
};

const NewsCTACard = (props: Props) => {
  return (
    <div className={classNames(styles.card, props.cardClassName)}>
      <div className={styles.content}>
        <div className={styles.iconCircle}>
          <img
            src={props.section.fields.image?.fields.file.url}
            className={styles.icon}
          />
        </div>
        <h3 className={styles.title}>{props.section.fields.displayTitle}</h3>
        <p className={styles.description}>{props.section.fields.textContent}</p>
      </div>
      <div className={styles.buttonContainer}>
        <Button type="inline" arrow href={props.section.fields.linkLocation}>
          {props.section.fields.linkText}
        </Button>
      </div>
    </div>
  );
};

export default NewsCTACard;
